import { ICustomerOrder } from '../interfaces'
import { yfSubscriptionPrivateService } from '../services'
import { collectionsStore } from '../components/collections/collections.store';

export enum TagAction {
  ADD = 'add',
  REMOVE = 'remove'
}

export const useFavouriteOrder = () => {
  const updateOrderTags = async (order: ICustomerOrder, action: TagAction) => {
    const favouriteInputData = {
      orderId: order.id.toString(),
      customerId: order.customer.id.toString()
    }
    let response = null

    if (action === TagAction.ADD) {
      response = await yfSubscriptionPrivateService.addFavouriteTag(favouriteInputData)

      if (!(response && response.data && response.data.tagsAdd && response.data.tagsAdd.node.id)) {
        return null
      } else {
        return response.data.tagsAdd.node.id
      }
    }

    if (action === TagAction.REMOVE) {
      response = await yfSubscriptionPrivateService.removeFavouriteTag(favouriteInputData)

      if (!(response && response.data && response.data.tagsRemove && response.data.tagsRemove.node.id)) {
        return null
      } else {
        return response.data.tagsRemove.node.id
      }
    } 
  }

  const setFavouriteOrder = async (currentOrder: ICustomerOrder) => {
    if (collectionsStore.favouriteOrders.length > 0) {
      // remove the favourite tag from order
      collectionsStore.favouriteOrders.forEach(async favouriteOrder => {
        await updateOrderTags(favouriteOrder, TagAction.REMOVE)
      })

      // add the favourite tag to the order
      return await updateOrderTags(currentOrder, TagAction.ADD)
    }

    // add the favourite tag to the order
    return await updateOrderTags(currentOrder, TagAction.ADD)
  }

  return { setFavouriteOrder, updateOrderTags }
}
